/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgMilitaryAlt48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        fill='#D6F5FF'
        fillRule='evenodd'
        d='M12.247 39.34v-4.454h5.443c2.132 1.555 2.128 3.008 1.98 4.454h-7.423zm23.752 0v-4.454h-5.806c-1.866 1.38-2.087 2.909-2.111 4.454h7.917zM8.29 21.631v-4.348h13.484l2.423 1.273 2.525-1.273h12.742v4.348H8.288zm12.37-10.992v-2.97h2.474v2.97H20.66z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M23.133 10.2V8.122c-3.311-1.297-6.471-1.307-9.475 0V10.2'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M40.123 21.103l-1.65-7.33a4.65 4.65 0 00-4.536-3.629H13.985a4.65 4.65 0 00-4.536 3.629l-1.65 7.33M16.436 10.144V21.25'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M11.471 31.515H3.059v11.734c0 .273.22.495.494.495h7.423a.495.495 0 00.495-.495V31.515v0z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M2.968 35.454h8.412M2.968 38.126h8.412M2.968 40.799h8.412'
      />
      <path fill='currentColor' d='M11.38 31.918H2.968v1.887h8.412v-1.887z' />
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M36.5 39.79H11.458M11.751 34.977h4.902c1.092 0 2.063.691 2.422 1.723l1.088 3.135'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M46.354 30.942l-1.588-9.838H3.158L1.57 30.942h44.784z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M31.488 10.144V21.25'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M44.89 31.515h-8.413v11.734c0 .273.222.495.495.495h7.423a.495.495 0 00.495-.495V31.515v0z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M36.387 35.454h8.412M36.387 38.126h8.412M36.387 40.799h8.412'
      />
      <path fill='currentColor' d='M44.8 31.918h-8.413v1.887h8.412v-1.887z' />
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M36.174 34.977h-4.902c-1.091 0-2.063.691-2.421 1.723l-1.09 3.135M28.081 10.144V2.227M35.162 26.052h4.302M31.049 26.052h2.322'
      />
      <path
        fill='#fff'
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M10.752 27.698a1.608 1.608 0 100-3.216 1.608 1.608 0 000 3.216z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M24.333 18.163a2.474 2.474 0 100-4.949 2.474 2.474 0 000 4.949z'
      />
    </svg>
  );
}

export default SvgMilitaryAlt48;
